import apiPrd from '../../services/apiPrd'

const DriverServices = {
  async postNewDriver(payload) {
    const res = await apiPrd.post('/driver', payload)
    return res.data
  },
  async update(id, payload) {
    const res = await apiPrd.put(`/driver/${id}`, payload)
    return res.data
  },
  async deleteDriver(id) {
    const res = await apiPrd.delete(`/driver/${id}`)
    return res.data
  },
  async validateCellphone(payload) {
    const res = await apiPrd.post(`/driver/${payload.id}/requestTokenCellphone`, payload)
    return res.data
  },
}

export default DriverServices
